import React from "react";
import StaticContentPage from "./StaticContentPage";
import { disclaimerText } from "../data/staticPagesContent";

const Disclaimer = () => {
  return (
    <StaticContentPage
      title="Disclaimer"
      seoTitle="Disclaimer | Eveness"
      seoDescription="Read the Eveness disclaimer covering website information, product guidance, styling suggestions, and platform usage."
      canonicalPath="/disclaimer"
    >
      {disclaimerText}
    </StaticContentPage>
  );
};

export default Disclaimer;